import styles from './PopupModel.module.scss';
import popClose from 'assets/images/pop-close.svg';
import { Button } from 'semantic-ui-react';
import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
// import { useDispatch, useSelector, connect, shallowEqual } from 'react-redux';
import Label from '../../../constants/Label';

function PopupModel(props) {
  const history = useHistory();
  const location = useLocation();
  const url = props.url;
  let [hide, setN] = useState(true);
  // const hidePopup = () => setN(false);
  const hidePopup = () => {
    setN(false);
    // props.data?.statusCode == '200' && location.path == 'add-customer'
    props.data?.statusCode == '200' || props.data?.statusCode == '201'
      ? history.push({ pathname: url[0], state: {} })
      : history.push({ pathname: url[1], state: {} });
    // return props.redirect
  };

  return (
    <>
      {hide ? (
        <div className={styles.dialogue}>
          <div className={styles.dialogue__wrap}>
            <img className={styles.dialogue__close} src={popClose} onClick={hidePopup} />
            {props.data?.statusCode == '200' || props.data?.statusCode == '401' ? <p>{props.data?.message}</p> : <p>{props.data?.message}</p>}
            <div className={styles.dialogue__buttons}>
              <Link onClick={hidePopup}>OK</Link>
              {/* <Link onClick={hidePopup} className={styles.LoginPage__link}>
                    Cancel
                    </Link> */}
              {/* <Button onClick={hidePopup} className={styles.LoginPage__link} > Ok</Button> 
                    <Button onClick={hidePopup} className={styles.LoginPage__link} > Cancel</Button>  */}
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
}
export { PopupModel };

function Popup(props) {
  let [hide, setN] = useState(props.active);
  const hidePopup = () => setN(false);
  return (
    <>
      {hide ? (
        <div className={styles.dialogue}>
          <div className={styles.dialogue__wrap}>
            <img className={styles.dialogue__close} src={popClose} onClick={hidePopup} />
            <p>{props.message}</p>
            <div className={styles.dialogue__buttons}>
              <Link onClick={hidePopup}>OK</Link>
            </div>
          </div>
        </div>
      ) : (
        window.location.reload()
      )}
      {/* {!hide? (<div>{props.redirect}</div>):""} */}
    </>
  );
}
export { Popup };
